export default "__VITE_ASSET__JnI1EMiy__"